import {BI_MODAL_BUTTONS, BI_ORIGINS, ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useState} from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {useAppActions} from '../../../../hooks/runtime'
import {AccessibilityMode} from '../accessibility-mode'
import {Footer} from '../footer'
import {Plan} from '../plan'
import {PricesOverlay} from '../prices-overlay'
import {OldTicketDescription, TicketDescription} from '../ticket-description'
import {Tickets} from '../tickets'
import {MobileProps} from './interfaces'
import {classes} from './mobile.st.css'

export const Mobile = ({
  placesInBasket,
  selectedPlace,
  onRemoveClick,
  onCheckoutClick,
  onPlaceClick,
  onCloseClick,
  showAccessibilityMode,
  placesInBasketCount,
  descriptionPlace,
  selectSeatForDescription,
  showDescription,
  setShowMobileBasket,
  showMobileBasket,
  locale,
}: MobileProps) => {
  const {t} = useTranslation()
  const [pricesOverlayOpen, setPricesOverlayOpen] = useState(false)
  const {getFormattedMoney, getTicketPriceText} = useCurrencyFormatter(locale)
  const {clickPlace, resetAreaCounterValue, seatingMapButtonClick} = useAppActions()

  const onPricesOverlayClose = () => {
    setPricesOverlayOpen(false)
    seatingMapButtonClick(BI_MODAL_BUTTONS.HIDE_PRICES)
  }

  const onPricesOverlayOpen = () => {
    setPricesOverlayOpen(true)
    seatingMapButtonClick(BI_MODAL_BUTTONS.SHOW_PRICES)
  }

  const {experiments} = useExperiments()
  const planTicketsDesignEnabled = experiments.enabled(ExperimentNames.PlanTicketsDesign)

  const handleDescriptionClose = () => {
    selectSeatForDescription(null)
    resetAreaCounterValue({place: descriptionPlace})
  }

  return (
    <div
      className={classNames(classes.container, {
        [classes.listContainer]: showAccessibilityMode,
        [classes.height]: planTicketsDesignEnabled && showAccessibilityMode,
      })}
    >
      <Tickets
        placesInBasketCount={placesInBasketCount}
        showAccessibilityMode={showAccessibilityMode}
        placesInBasket={placesInBasket}
        show={showMobileBasket}
        onBackClick={() => setShowMobileBasket(false)}
        onRemoveClick={onRemoveClick}
        onCheckoutClick={onCheckoutClick}
        onTicketMoreInfoClick={selectSeatForDescription}
        chooseSeatMode={false}
        chooseMultipleSeatsMode={false}
      />
      {planTicketsDesignEnabled ? (
        <TicketDescription
          showAccessibilityMode={showAccessibilityMode}
          show={showDescription}
          place={descriptionPlace}
          onClose={handleDescriptionClose}
          onTicketClick={() =>
            clickPlace({
              place: descriptionPlace,
              origin: BI_ORIGINS.SEATINGS_MODAL_TICKET_DESCRIPTION,
              updateShownDescription: true,
            })
          }
        />
      ) : (
        <OldTicketDescription
          show={showDescription}
          place={descriptionPlace}
          onClose={() => selectSeatForDescription(null)}
        />
      )}
      {showAccessibilityMode ? (
        <AccessibilityMode onFooterButtonClick={() => setShowMobileBasket(true)} />
      ) : (
        <>
          <Plan onPlaceClick={onPlaceClick} forcedPopoverPlanPlaceId={null} />
          <Footer
            showAccessibilityMode={showAccessibilityMode}
            onPricesOverlayOpen={onPricesOverlayOpen}
            withoutBreakdown={true}
            selectedPlace={selectedPlace}
            inDrawer={true}
            onCloseClick={onCloseClick}
            onCheckoutClick={() => setShowMobileBasket(true)}
          />
          <PricesOverlay
            t={t}
            pricesOverlayOpen={pricesOverlayOpen}
            onClose={onPricesOverlayClose}
            getFormattedMoney={getFormattedMoney}
            getTicketPriceText={getTicketPriceText}
          />
        </>
      )}
    </div>
  )
}
